import React from 'react'
import { SelectUser, Button, ConfirmModal } from '@Knowledge-OTP/znk-ui-components'
import useTranslation from '../../../../../i18n/useTranslation'
const CounselorSelector = (props) => {
  const {
    title,
    onClick = () => { },
    activeUsers = [],
    selections = [],
    setSelectUser,
    ordenateUserArray,
    isOpenConfirmModal,
    setIsOpenConfirmModal,
    activity
  } = props
  const toggle = () => { setIsOpenConfirmModal(!isOpenConfirmModal) }
  const { translate, replaceVariables } = useTranslation()
  const selectedUserIds = selections
    .filter((selection) => selection.userId)
    .map((selection) => selection.userId)
  const selectedUsers = activeUsers?.filter((user) => selectedUserIds.includes(user.id)) || []

  return (

    <div className='mt-4'>
      <span>{title}</span>
      <div className='d-flex flex-row mb-4 mt-1'>
        <div className='d-flex flex-column w-40'>
          {
            activeUsers?.length > 0 && selections.map((selection, index) => (
              <SelectUser
                key={selection.globalVarId}
                className='my-2 w-100'
                activeUsers={activeUsers.filter((user) => (
                  user.id === selection.userId || !selectedUserIds.includes(user.id)
                ))}
                selectUser={selection.userId}
                setSelectUser={(userId) => { setSelectUser(index, userId) }}
                ordenateUserArray={ordenateUserArray}
              />
            ))
          }
        </div>
        <Button
          color='primary'
          activity={false}
          className='h-60 mt-1 col-2 ml-2'
          label='Save'
          disabled={!selectedUserIds.length}
          onClick={() => { setIsOpenConfirmModal(true) }}
          style={{ borderRadius: `${'16px 16px 16px 16px'}` }}
        />
      </div>
      <ConfirmModal
        className='m-4'
        isOpen={isOpenConfirmModal}
        toggle={toggle}
        loading={null}
        activity={activity}
        title={translate(
          'globalCounselors.title'
        )}
        body={replaceVariables(
          translate(
            'globalCounselors.body'
          ),
          { COUNSELOR: selectedUsers.map((user) => `${user.firstName} ${user.lastName}`).join(', ') }
        )}
        classNameActionDiv='d-flex flex-column justify-content-end w-80'
        confirmAction={() => { onClick() }}
        cancelAction={toggle}
        confirmText={translate(
          'globalCounselors.confirmText'
        )}
        cancelText={translate(
          'globalCounselors.cancelText'
        )}
      />
    </div>

  )
}

export default CounselorSelector
